import { useEffect, useRef, useState } from "react";

const findSeasonById = (seasons, seasonId) => seasons.find((season) => season.value === seasonId);

const applySeasonDates = ({ season, handleFilterChange }) => {
	if (!season) {
		return;
	}

	if (season.start_date) {
		handleFilterChange("date_from", season.start_date);
	}
	if (season.end_date) {
		handleFilterChange("date_to", season.end_date);
	}
};

const initializeSeasonDates = ({ seasons, seasonInitializedRef, handleFilterChange, setPendingApply, setIsReady }) => {
	const activeSeason = seasons.find((season) => season.active === true || season.active === 1);
	if (activeSeason && !seasonInitializedRef.current) {
		handleFilterChange("season_id", activeSeason.value);
		applySeasonDates({ season: activeSeason, handleFilterChange });

		seasonInitializedRef.current = true;
		setPendingApply(true);
		return;
	}

	if (!seasonInitializedRef.current) {
		seasonInitializedRef.current = true;
		setIsReady(true);
	}
};

export function useOtherMovementsHistoryFilters({ lookups, filtersState, setFilterOptions, handleFilterChange, handleApplyFilters }) {
	const seasonInitializedRef = useRef(false);
	const selectedSeasonIdRef = useRef("");
	const [pendingApply, setPendingApply] = useState(false);
	const [isReady, setIsReady] = useState(false);

	useEffect(() => {
		if (!lookups) return;

		if (lookups.movement_types) {
			setFilterOptions("movement_type_id", lookups.movement_types, false);
		}

		if (lookups.seasons) {
			setFilterOptions("season_id", lookups.seasons, false);
			initializeSeasonDates({
				seasons: lookups.seasons,
				seasonInitializedRef,
				handleFilterChange,
				setPendingApply,
				setIsReady,
			});
		} else {
			setIsReady(true);
		}
	}, [lookups, setFilterOptions, handleFilterChange]);

	useEffect(() => {
		if (!lookups?.seasons || !filtersState?.length) {
			return;
		}

		const seasonFilter = filtersState.find((filterItem) => filterItem.key === "season_id");
		const selectedSeasonId = seasonFilter?.value;

		if (!selectedSeasonId || selectedSeasonIdRef.current === selectedSeasonId) {
			return;
		}

		const selectedSeason = findSeasonById(lookups.seasons, selectedSeasonId);
		if (!selectedSeason) {
			return;
		}

		selectedSeasonIdRef.current = selectedSeasonId;
		applySeasonDates({ season: selectedSeason, handleFilterChange });
	}, [lookups, filtersState, handleFilterChange]);

	useEffect(() => {
		if (pendingApply && handleApplyFilters && filtersState) {
			const dateFromFilter = filtersState.find((filterItem) => filterItem.key === "date_from");
			const dateToFilter = filtersState.find((filterItem) => filterItem.key === "date_to");

			if (dateFromFilter?.value && dateToFilter?.value) {
				handleApplyFilters();
				setPendingApply(false);
				setIsReady(true);
			}
		}
	}, [pendingApply, filtersState, handleApplyFilters]);

	return { isReady };
}
